module.exports = __webpack_public_path__ + "static/media/search.91e75659.svg";